// キャッシュ対象一覧の正規化応答(Works の軽量プレビュー行 + 空の related)を、
// キャッシュページが使う一覧行へ変換する。工事(Work)は担当者を持たず related 結合は不要なため、
// トップの Works をそのまま返す(旧 ConstructionWork の User 結合は廃止)。
import { NormalizedCacheableWorksResponse, WorkPreviewRow } from "../../schema/console/cache";

export function hydrateCacheableWorks(normalized: NormalizedCacheableWorksResponse): WorkPreviewRow[] {
  return normalized.Works;
}
